/**
 * Fix for resource-list carousels to scroll one slide at a time
 * and ensure smooth animations
 */

(function() {
  'use strict';
  
  function initCarouselFix() {
    // Find all resource-list carousels
    const carousels = document.querySelectorAll('.resource-list--centered slideshow-component');
    
    carousels.forEach((slideshow) => {
      // Skip if already fixed
      if (slideshow.dataset.carouselFixApplied) return;
      slideshow.dataset.carouselFixApplied = 'true';
      
      // Wait for slideshow to be fully initialized
      const checkSlideshow = setInterval(() => {
        if (slideshow.slides && slideshow.slides.length > 0) {
          clearInterval(checkSlideshow);
          applyFix(slideshow);
        }
      }, 100);
      
      // Timeout after 2 seconds
      setTimeout(() => clearInterval(checkSlideshow), 2000);
    });
  }
  
  function applyFix(slideshow) {
    // Store original methods
    const originalNext = slideshow.next.bind(slideshow);
    const originalPrevious = slideshow.previous.bind(slideshow);
    
    // Override next method to move 1 slide at a time
    slideshow.next = function(event, options) {
      event?.preventDefault();
      const current = this.current || 0;
      const nextIndex = current + 1;
      const slides = this.slides;
      
      if (slides && nextIndex < slides.length) {
        this.select(nextIndex, event, { ...options, animate: false });
      }
    };
    
    // Override previous method to move 1 slide at a time
    slideshow.previous = function(event, options) {
      event?.preventDefault();
      const current = this.current || 0;
      const previousIndex = current - 1;
      
      if (previousIndex >= 0) {
        this.select(previousIndex, event, { ...options, animate: false });
      }
    };
    
    // Ensure smooth scrolling on the scroller element
    const scroller = slideshow.querySelector('slideshow-slides');
    if (scroller) {
      scroller.style.scrollBehavior = 'smooth';
    }
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarouselFix);
  } else {
    initCarouselFix();
  }
  
  // Also listen for dynamically added carousels
  const observer = new MutationObserver(initCarouselFix);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

